/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloEstadosDetalles from 'Infotrack@Modelos/smartStock/estadosDetalles';
import IEstadosDetalles from 'Infotrack@Modelos/smartStock/estadosDetalles/entidades/estadosDetalles';

export default class ControladorModeloEstadosDetalles {
    private modeloEstadosDetalles: ModeloEstadosDetalles;
    constructor() {
        this.modeloEstadosDetalles = new ModeloEstadosDetalles();
    }

    public consultarEstadosDetalles() {
        return this.modeloEstadosDetalles.consultarEstadosDetalles().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearEstadosDetalles(estadosDetalles: IEstadosDetalles) {
        await this.modeloEstadosDetalles.crearEstadosDetalles(estadosDetalles);
    }

    public async editarEstadosDetalles(estadosDetalles: IEstadosDetalles) {
        await this.modeloEstadosDetalles.editarEstadosDetalles(estadosDetalles);
    }
    public async eliminarEstadosDetalles(estadosDetalles: IEstadosDetalles) {
        await this.modeloEstadosDetalles.eliminarEstadosDetalles(estadosDetalles);
    }

    public validarEntidad(estadosDetalles: IEstadosDetalles): boolean {
        if (estadosDetalles.DescripcionEstadoDetalle === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
